export default __webpack_public_path__ + "static/media/josephine.f6c21f7a.jpg";